import { SubscriptionPeriod } from '@anm/api/modules/subscription';
import capitalize from '@anm/helpers/string/capitalize';

export type PeriodName = 'Annual' | 'Monthly' | 'Lifetime' | 'Coupon';

const getPeriodName = (period: SubscriptionPeriod): PeriodName =>
  capitalize(period) as PeriodName;

export default getPeriodName;
